import {
  Receipt,
  Person,
} from "@mui/icons-material";
import {
  Divider,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { Link, useLocation } from "react-router-dom";
import { Colors } from 'helpers/Consts'

type Props = {
  anchorEl: null | HTMLElement;
  open: boolean;
  handleClose: () => void;
  name?: string;
};

export default function MenuNavBar({
  anchorEl,
  open,
  handleClose,
  name,
}: Props) {
  const { search } = useLocation()

  return (
    <Menu
      anchorEl={anchorEl}
      id="account-menu"
      open={open}
      onClose={handleClose}
      onClick={handleClose}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          mt: 1.5,
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            transform: "translateY(-50%) rotate(45deg)",
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <Box padding={2}>
        <Box paddingLeft={2} paddingBottom={1}>
          <Typography variant="h5">Olá, {name}</Typography>
        </Box>
        <Divider />
        <Box sx={{ paddingTop: 1 }}>
          <Box
            component={Link}
            to={`/settings${search}`}
            sx={{
              textDecoration: "none",
              color: Colors.baseTextColor
            }}
          >
            <MenuItem>
              <ListItemIcon sx={{
                  marginRight: 1.5
              }}>
                <Person fontSize="small" />
              </ListItemIcon>
              Editar Perfil
            </MenuItem>
          </Box>
          <Box
            component={Link}
            to={`/orders${search}`}
            sx={{
              textDecoration: "none",
              color: Colors.baseTextColor
            }}
          >
            <MenuItem>
              <ListItemIcon sx={{
                  marginRight: 1.5
              }}>
                <Receipt fontSize="small" />
              </ListItemIcon>
              Pedidos
            </MenuItem>
          </Box>
        </Box>
      </Box>
    </Menu>
  );
}
